export const PMessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 21.25H7C3.35 21.25 1.25 19.15 1.25 15.5V8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25ZM7 4.25C4.14 4.25 2.75 5.64 2.75 8.5V15.5C2.75 18.36 4.14 19.75 7 19.75H17C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7Z"
        fill="url(#paint0_linear_5302_3521)"
      />
      <path
        d="M11.9998 12.87C11.1598 12.87 10.3098 12.61 9.65978 12.08L6.52978 9.57997C6.20978 9.31997 6.14978 8.84997 6.40978 8.52997C6.66978 8.20997 7.13978 8.14997 7.45978 8.40997L10.5898 10.91C11.3498 11.52 12.6398 11.52 13.3998 10.91L16.5298 8.40997C16.8498 8.14997 17.3298 8.19997 17.5798 8.52997C17.8398 8.84997 17.7898 9.32997 17.4598 9.57997L14.3298 12.08C13.6898 12.61 12.8398 12.87 11.9998 12.87Z"
        fill="url(#paint1_linear_5302_3521)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5302_3521"
          x1="-3.20357"
          y1="5.525"
          x2="24.0019"
          y2="15.7185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5302_3521"
          x1="3.86523"
          y1="8.93801"
          x2="13.9687"
          y2="17.0351"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PPhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z"
        fill="url(#paint0_linear_3804_28703)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3804_28703"
          x1="-3.19529"
          y1="4.475"
          x2="24.8658"
          y2="13.5052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PCapIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46435 2.82057C11.0871 2.05981 12.9128 2.05981 14.5356 2.82057L21.2268 5.95756C22.2791 6.4509 22.75 7.52222 22.75 8.50002C22.75 9.47782 22.2791 10.5491 21.2268 11.0425L19.75 11.7348V16.6254C19.75 17.8785 19.1217 19.0883 17.978 19.7217C17.2263 20.138 16.2384 20.6391 15.1988 21.038C14.1715 21.4321 13.0339 21.75 12 21.75C10.9661 21.75 9.82851 21.4321 8.80116 21.038C7.76158 20.6391 6.77371 20.138 6.02198 19.7217C4.87826 19.0883 4.25 17.8785 4.25 16.6254V11.7348L2.77323 11.0424L2.75 11.0314V14C2.75 14.4142 2.41421 14.75 2 14.75C1.58579 14.75 1.25 14.4142 1.25 14V8.5C1.25 7.5222 1.72095 6.45085 2.77324 5.95752L9.46435 2.82057ZM5.75 12.438V16.6254C5.75 17.3884 6.12875 18.0661 6.74868 18.4095C7.46533 18.8063 8.38678 19.2724 9.33844 19.6375C10.3023 20.0073 11.2379 20.25 12 20.25C12.7621 20.25 13.6977 20.0073 14.6616 19.6375C15.6132 19.2724 16.5347 18.8063 17.2513 18.4095C17.8713 18.0661 18.25 17.3884 18.25 16.6254V12.4381L14.5357 14.1794C12.9129 14.9402 11.0872 14.9402 9.46444 14.1794L5.75 12.438ZM3.40996 9.68429C3.00679 9.49527 2.75 9.04438 2.75 8.49998C2.75 7.95557 3.00679 7.50469 3.40997 7.31567L10.1011 4.17872C11.3204 3.60709 12.6795 3.60709 13.8988 4.17873L20.59 7.31571C20.9932 7.50473 21.25 7.95562 21.25 8.50002C21.25 9.04443 20.9932 9.49531 20.59 9.68433L13.8989 12.8213C12.6796 13.3929 11.3205 13.3929 10.1012 12.8213L3.40996 9.68429Z"
        fill="url(#paint0_linear_3804_28540)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3804_28540"
          x1="-3.20357"
          y1="5.175"
          x2="24.3407"
          y2="14.9662"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PUserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C9.92893 4 8.25 5.67893 8.25 7.75C8.25 9.82107 9.92893 11.5 12 11.5C14.0711 11.5 15.75 9.82107 15.75 7.75C15.75 5.67893 14.0711 4 12 4ZM9.75 7.75C9.75 6.50736 10.7574 5.5 12 5.5C13.2426 5.5 14.25 6.50736 14.25 7.75C14.25 8.99264 13.2426 10 12 10C10.7574 10 9.75 8.99264 9.75 7.75Z"
        fill="url(#paint0_linear_3804_28553)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13C6.92893 13 5.25 14.6789 5.25 16.75C5.25 18.8211 6.92893 20.5 9 20.5H15C17.0711 20.5 18.75 18.8211 18.75 16.75C18.75 14.6789 17.0711 13 15 13H9ZM6.75 16.75C6.75 15.5074 7.75736 14.5 9 14.5H15C16.2426 14.5 17.25 15.5074 17.25 16.75C17.25 17.9926 16.2426 19 15 19H9C7.75736 19 6.75 17.9926 6.75 16.75Z"
        fill="url(#paint1_linear_3804_28553)"
      />
      <path
        d="M7.75214 10.3887C7.59441 10.1353 7.29846 10 7 10C5.75736 10 4.75 8.99264 4.75 7.75C4.75 6.50736 5.75736 5.5 7 5.5C7.29846 5.5 7.59441 5.36473 7.75214 5.11135C7.75912 5.10014 7.76613 5.08896 7.7732 5.07782C8.0358 4.66331 7.90275 4.0764 7.415 4.0227C7.27873 4.0077 7.14027 4 7 4C4.92893 4 3.25 5.67893 3.25 7.75C3.25 9.82107 4.92893 11.5 7 11.5C7.14027 11.5 7.27873 11.4923 7.415 11.4773C7.90275 11.4236 8.0358 10.8367 7.7732 10.4222C7.76614 10.411 7.75912 10.3999 7.75214 10.3887Z"
        fill="url(#paint2_linear_3804_28553)"
      />
      <path
        d="M4.70829 18.3169C4.59477 18.1275 4.39439 18 4.17359 18H4C2.75736 18 1.75 16.9926 1.75 15.75C1.75 14.5074 2.75736 13.5 4 13.5H4.17359C4.39439 13.5 4.59477 13.3725 4.70829 13.1831C4.98539 12.7208 4.68468 12 4.14569 12H4C1.92893 12 0.25 13.6789 0.25 15.75C0.25 17.8211 1.92893 19.5 4 19.5H4.14569C4.68469 19.5 4.98539 18.7792 4.70829 18.3169Z"
        fill="url(#paint3_linear_3804_28553)"
      />
      <path
        d="M16.2268 10.4222C15.9642 10.8367 16.0973 11.4236 16.585 11.4773C16.7213 11.4923 16.8597 11.5 17 11.5C19.0711 11.5 20.75 9.82107 20.75 7.75C20.75 5.67893 19.0711 4 17 4C16.8597 4 16.7213 4.0077 16.585 4.0227C16.0973 4.0764 15.9642 4.66331 16.2268 5.07782C16.2339 5.08896 16.2409 5.10014 16.2479 5.11134C16.4056 5.36472 16.7015 5.5 17 5.5C18.2426 5.5 19.25 6.50736 19.25 7.75C19.25 8.99264 18.2426 10 17 10C16.7015 10 16.4056 10.1353 16.2479 10.3887C16.2409 10.3999 16.2339 10.411 16.2268 10.4222Z"
        fill="url(#paint4_linear_3804_28553)"
      />
      <path
        d="M19.2917 18.3169C19.0146 18.7792 19.3153 19.5 19.8543 19.5H20C22.0711 19.5 23.75 17.8211 23.75 15.75C23.75 13.6789 22.0711 12 20 12H19.8543C19.3153 12 19.0146 12.7208 19.2917 13.1831C19.4052 13.3725 19.6056 13.5 19.8264 13.5H20C21.2426 13.5 22.25 14.5074 22.25 15.75C22.25 16.9926 21.2426 18 20 18H19.8264C19.6056 18 19.4052 18.1275 19.2917 18.3169Z"
        fill="url(#paint5_linear_3804_28553)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3804_28553"
          x1="-4.61786"
          y1="6.475"
          x2="23.388"
          y2="19.3348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3804_28553"
          x1="-4.61786"
          y1="6.475"
          x2="23.388"
          y2="19.3348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3804_28553"
          x1="-4.61786"
          y1="6.475"
          x2="23.388"
          y2="19.3348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3804_28553"
          x1="-4.61786"
          y1="6.475"
          x2="23.388"
          y2="19.3348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3804_28553"
          x1="-4.61786"
          y1="6.475"
          x2="23.388"
          y2="19.3348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3804_28553"
          x1="-4.61786"
          y1="6.475"
          x2="23.388"
          y2="19.3348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PLocIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 28"
      fill="none"
    >
      <path
        d="M15.3177 22.1164L14.8751 21.7693L15.3177 22.1164ZM8.96325 22.1164L8.52067 22.4635L8.96325 22.1164ZM12.1405 24.75V24.1876V24.75ZM20.7185 10.5859C20.7185 12.0686 19.9533 14.0008 18.7994 16.0408C17.658 18.0587 16.1862 20.0975 14.8751 21.7693L15.7603 22.4635C17.0883 20.7701 18.598 18.6816 19.7785 16.5946C20.9465 14.5296 21.8434 12.3792 21.8434 10.5859H20.7185ZM9.40584 21.7693C8.09478 20.0975 6.62294 18.0587 5.48154 16.0408C4.32769 14.0008 3.56244 12.0686 3.56244 10.5859H2.43756C2.43756 12.3792 3.33442 14.5296 4.50244 16.5946C5.68291 18.6816 7.1927 20.7701 8.52067 22.4635L9.40584 21.7693ZM3.56244 10.5859C3.56244 5.42478 7.44109 1.31244 12.1405 1.31244V0.187561C6.74357 0.187561 2.43756 4.88263 2.43756 10.5859H3.56244ZM12.1405 1.31244C16.8399 1.31244 20.7185 5.42478 20.7185 10.5859H21.8434C21.8434 4.88263 17.5374 0.187561 12.1405 0.187561V1.31244ZM14.8751 21.7693C14.1744 22.6629 13.6913 23.2758 13.2516 23.6753C12.8359 24.0528 12.5147 24.1876 12.1405 24.1876V25.3124C12.8783 25.3124 13.4572 25.0082 14.0079 24.5079C14.5346 24.0295 15.0842 23.3256 15.7603 22.4635L14.8751 21.7693ZM8.52067 22.4635C9.19675 23.3256 9.74633 24.0295 10.273 24.5079C10.8238 25.0082 11.4027 25.3124 12.1405 25.3124V24.1876C11.7663 24.1876 11.445 24.0528 11.0294 23.6753C10.5896 23.2758 10.1066 22.6629 9.40584 21.7693L8.52067 22.4635ZM8.15036 11.033C8.15036 13.2367 9.93679 15.0232 12.1405 15.0232V13.8983C10.558 13.8983 9.27524 12.6155 9.27524 11.033H8.15036ZM12.1405 15.0232C14.3442 15.0232 16.1306 13.2367 16.1306 11.033H15.0057C15.0057 12.6155 13.7229 13.8983 12.1405 13.8983V15.0232ZM16.1306 11.033C16.1306 8.82935 14.3442 7.04292 12.1405 7.04292V8.16779C13.7229 8.16779 15.0057 9.45061 15.0057 11.033H16.1306ZM12.1405 7.04292C9.93679 7.04292 8.15036 8.82935 8.15036 11.033H9.27524C9.27524 9.45061 10.558 8.16779 12.1405 8.16779V7.04292Z"
        fill="url(#paint0_linear_3804_28719)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3804_28719"
          x1="-0.786768"
          y1="4.35"
          x2="24.0925"
          y2="10.4598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PBagIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 22.7498H7.99998C3.37998 22.7498 2.51998 20.5998 2.29998 18.5098L1.54998 10.4998C1.43998 9.44977 1.40998 7.89977 2.44998 6.73977C3.34998 5.73977 4.83998 5.25977 6.99998 5.25977H17C19.17 5.25977 20.66 5.74977 21.55 6.73977C22.59 7.89977 22.56 9.44977 22.45 10.5098L21.7 18.4998C21.48 20.5998 20.62 22.7498 16 22.7498ZM6.99998 6.74977C5.30998 6.74977 4.14998 7.07977 3.55998 7.73977C3.06998 8.27977 2.90998 9.10977 3.03998 10.3498L3.78998 18.3598C3.95998 19.9398 4.38998 21.2498 7.99998 21.2498H16C19.6 21.2498 20.04 19.9398 20.21 18.3498L20.96 10.3598C21.09 9.10977 20.93 8.27977 20.44 7.73977C19.85 7.07977 18.69 6.74977 17 6.74977H6.99998Z"
        fill="url(#paint0_linear_5302_4335)"
      />
      <path
        d="M16 6.75C15.59 6.75 15.25 6.41 15.25 6V5.2C15.25 3.42 15.25 2.75 12.8 2.75H11.2C8.75 2.75 8.75 3.42 8.75 5.2V6C8.75 6.41 8.41 6.75 8 6.75C7.59 6.75 7.25 6.41 7.25 6V5.2C7.25 3.44 7.25 1.25 11.2 1.25H12.8C16.75 1.25 16.75 3.44 16.75 5.2V6C16.75 6.41 16.41 6.75 16 6.75Z"
        fill="url(#paint1_linear_5302_4335)"
      />
      <path
        d="M12 16.75C9.25 16.75 9.25 15.05 9.25 14.03V13C9.25 11.59 9.59 11.25 11 11.25H13C14.41 11.25 14.75 11.59 14.75 13V14C14.75 15.04 14.75 16.75 12 16.75ZM10.75 12.75C10.75 12.83 10.75 12.92 10.75 13V14.03C10.75 15.06 10.75 15.25 12 15.25C13.25 15.25 13.25 15.09 13.25 14.02V13C13.25 12.92 13.25 12.83 13.25 12.75C13.17 12.75 13.08 12.75 13 12.75H11C10.92 12.75 10.83 12.75 10.75 12.75Z"
        fill="url(#paint2_linear_5302_4335)"
      />
      <path
        d="M14 14.7702C13.63 14.7702 13.3 14.4902 13.26 14.1102C13.21 13.7002 13.5 13.3202 13.91 13.2702C16.55 12.9402 19.08 11.9402 21.21 10.3902C21.54 10.1402 22.01 10.2202 22.26 10.5602C22.5 10.8902 22.43 11.3602 22.09 11.6102C19.75 13.3102 16.99 14.4002 14.09 14.7702C14.06 14.7702 14.03 14.7702 14 14.7702Z"
        fill="url(#paint3_linear_5302_4335)"
      />
      <path
        d="M9.99999 14.7799C9.96999 14.7799 9.93999 14.7799 9.90999 14.7799C7.16999 14.4699 4.49999 13.4699 2.18999 11.8899C1.84999 11.6599 1.75999 11.1899 1.98999 10.8499C2.21999 10.5099 2.68999 10.4199 3.02999 10.6499C5.13999 12.0899 7.56999 12.9999 10.07 13.2899C10.48 13.3399 10.78 13.7099 10.73 14.1199C10.7 14.4999 10.38 14.7799 9.99999 14.7799Z"
        fill="url(#paint4_linear_5302_4335)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5302_4335"
          x1="-2.8531"
          y1="7.88327"
          x2="23.505"
          y2="18.0888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5302_4335"
          x1="5.28214"
          y1="2.075"
          x2="15.7458"
          y2="7.90202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5302_4335"
          x1="8.11071"
          y1="12.075"
          x2="15.3"
          y2="14.3929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5302_4335"
          x1="11.3596"
          y1="10.9231"
          x2="20.6254"
          y2="16.9606"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5302_4335"
          x1="0.0245932"
          y1="11.1611"
          x2="8.84575"
          y2="17.0882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PLinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M14.729 2.8836C16.1633 1.44371 18.2614 1.41347 19.4229 2.57944C20.5865 3.74762 20.5552 5.85885 19.1199 7.29972L16.6961 9.73297C16.4037 10.0264 16.4047 10.5013 16.6981 10.7936C16.9916 11.086 17.4665 11.085 17.7588 10.7916L20.1826 8.35833C22.0939 6.43961 22.3339 3.37629 20.4856 1.52084C18.6351 -0.336815 15.5786 -0.0947025 13.6663 1.825L8.81866 6.69145C6.90736 8.61017 6.66741 11.6735 8.51567 13.529C8.808 13.8224 9.28287 13.8234 9.57633 13.531C9.86979 13.2387 9.87071 12.7638 9.57839 12.4704C8.41473 11.3022 8.44608 9.19092 9.88137 7.75006L14.729 2.8836Z"
        fill="url(#paint0_linear_5302_3549)"
      />
      <path
        d="M13.4856 8.47037C13.1933 8.17691 12.7184 8.17599 12.4249 8.46832C12.1315 8.76064 12.1305 9.23552 12.4229 9.52898C13.5865 10.6972 13.5552 12.8084 12.1199 14.2492L7.27226 19.1157C5.83794 20.5556 3.73986 20.5859 2.57839 19.4199C1.41473 18.2517 1.44607 16.1404 2.88138 14.6996L5.30522 12.2663C5.59755 11.9729 5.59663 11.498 5.30317 11.2057C5.00971 10.9133 4.53483 10.9143 4.24251 11.2077L1.81867 13.641C-0.0926361 15.5597 -0.332596 18.6231 1.51568 20.4785C3.36615 22.3362 6.4227 22.0941 8.33498 20.1744L13.1826 15.3078C15.0939 13.3891 15.3339 10.3258 13.4856 8.47037Z"
        fill="url(#paint1_linear_5302_3549)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5302_3549"
          x1="-4.20383"
          y1="3.47422"
          x2="23.9014"
          y2="12.5355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5302_3549"
          x1="-4.20383"
          y1="3.47422"
          x2="23.9014"
          y2="12.5355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PBadgeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 73 30"
      fill="none"
    >
      <path
        d="M0.632551 29.3674V0.632551H64.0231L71.95 15L64.0231 29.3674H0.632551Z"
        fill="#292929"
        stroke="url(#paint0_linear_3804_28467)"
        strokeWidth="1.2651"
      />
      <path
        d="M30.4902 22.001L26.1843 16.548H25.1078V22.001H22.9196V9.61274H25.1078V14.6422H26.149L30.4019 9.61274H33.0666L28.0196 15.5245L33.2431 22.001H30.4902ZM37.2484 9.61274H39.2778V22.001H37.1778V12.0657L34.2661 14.4304V12.0304L37.2484 9.61274Z"
        fill="url(#paint1_linear_3804_28467)"
      />
      <path
        d="M43.3333 8.33398L47.2489 13.889L48.6198 15.834L47.2481 17.7798L43.3333 23.334L45.4295 23.334L45.4369 23.323L45.432 23.334L46.38 23.334L51.6666 15.834L46.38 8.33398L45.4328 8.33398L45.4394 8.34832L45.4295 8.33398L43.3333 8.33398Z"
        fill="url(#paint2_linear_3804_28467)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3804_28467"
          x1="-15.0536"
          y1="4.5"
          x2="50.0832"
          y2="55.3716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFF9F" />
          <stop offset="0.9999" stopColor="#D2A84E" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3804_28467"
          x1="31.5264"
          y1="27.3162"
          x2="32.4583"
          y2="11.0091"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3804_28467"
          x1="55.3577"
          y1="16.2913"
          x2="44.0313"
          y2="15.662"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#D2A84E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PEditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z"
        fill="#D2A84E"
      />
      <path
        d="M8.50008 17.6896C7.89008 17.6896 7.33008 17.4696 6.92008 17.0696C6.43008 16.5796 6.22008 15.8696 6.33008 15.1196L6.76008 12.1096C6.84008 11.5296 7.22008 10.7796 7.63008 10.3696L15.5101 2.48957C17.5001 0.49957 19.5201 0.49957 21.5101 2.48957C22.6001 3.57957 23.0901 4.68957 22.9901 5.79957C22.9001 6.69957 22.4201 7.57957 21.5101 8.47957L13.6301 16.3596C13.2201 16.7696 12.4701 17.1496 11.8901 17.2296L8.88008 17.6596C8.75008 17.6896 8.62008 17.6896 8.50008 17.6896ZM16.5701 3.54957L8.69008 11.4296C8.50008 11.6196 8.28008 12.0596 8.24008 12.3196L7.81008 15.3296C7.77008 15.6196 7.83008 15.8596 7.98008 16.0096C8.13008 16.1596 8.37008 16.2196 8.66008 16.1796L11.6701 15.7496C11.9301 15.7096 12.3801 15.4896 12.5601 15.2996L20.4401 7.41957C21.0901 6.76957 21.4301 6.18957 21.4801 5.64957C21.5401 4.99957 21.2001 4.30957 20.4401 3.53957C18.8401 1.93957 17.7401 2.38957 16.5701 3.54957Z"
        fill="#D2A84E"
      />
      <path
        d="M19.8501 9.83027C19.7801 9.83027 19.7101 9.82027 19.6501 9.80027C17.0201 9.06027 14.9301 6.97027 14.1901 4.34027C14.0801 3.94027 14.3101 3.53027 14.7101 3.41027C15.1101 3.30027 15.5201 3.53027 15.6301 3.93027C16.2301 6.06027 17.9201 7.75027 20.0501 8.35027C20.4501 8.46027 20.6801 8.88027 20.5701 9.28027C20.4801 9.62027 20.1801 9.83027 19.8501 9.83027Z"
        fill="#D2A84E"
      />
    </svg>
  );
};

export const PUserEIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0002 22.7501C11.3302 22.7501 10.6502 22.5801 10.0502 22.2301L4.11016 18.8001C2.91016 18.1001 2.16016 16.8101 2.16016 15.4201V8.58011C2.16016 7.19011 2.91016 5.90011 4.11016 5.20011L10.0502 1.77012C11.2502 1.07012 12.7402 1.07012 13.9502 1.77012L19.8902 5.20011C21.0902 5.90011 21.8402 7.19011 21.8402 8.58011V15.4201C21.8402 16.8101 21.0902 18.1001 19.8902 18.8001L13.9502 22.2301C13.3502 22.5801 12.6702 22.7501 12.0002 22.7501ZM12.0002 2.7501C11.5902 2.7501 11.1702 2.8601 10.8002 3.0701L4.86016 6.5001C4.12016 6.9301 3.66016 7.72011 3.66016 8.58011V15.4201C3.66016 16.2701 4.12016 17.0701 4.86016 17.5001L10.8002 20.9301C11.5402 21.3601 12.4602 21.3601 13.2002 20.9301L19.1402 17.5001C19.8802 17.0701 20.3402 16.2801 20.3402 15.4201V8.58011C20.3402 7.73011 19.8802 6.9301 19.1402 6.5001L13.2002 3.0701C12.8302 2.8601 12.4102 2.7501 12.0002 2.7501Z"
        fill="white"
      />
      <path
        d="M11.9999 11.7498C10.2999 11.7498 8.91992 10.3698 8.91992 8.6698C8.91992 6.9698 10.2999 5.58984 11.9999 5.58984C13.6999 5.58984 15.0799 6.9698 15.0799 8.6698C15.0799 10.3698 13.6999 11.7498 11.9999 11.7498ZM11.9999 7.08984C11.1299 7.08984 10.4199 7.7998 10.4199 8.6698C10.4199 9.5398 11.1299 10.2498 11.9999 10.2498C12.8699 10.2498 13.5799 9.5398 13.5799 8.6698C13.5799 7.7998 12.8699 7.08984 11.9999 7.08984Z"
        fill="white"
      />
      <path
        d="M16 17.4103C15.59 17.4103 15.25 17.0703 15.25 16.6603C15.25 15.2803 13.79 14.1504 12 14.1504C10.21 14.1504 8.75 15.2803 8.75 16.6603C8.75 17.0703 8.41 17.4103 8 17.4103C7.59 17.4103 7.25 17.0703 7.25 16.6603C7.25 14.4503 9.38 12.6504 12 12.6504C14.62 12.6504 16.75 14.4503 16.75 16.6603C16.75 17.0703 16.41 17.4103 16 17.4103Z"
        fill="white"
      />
    </svg>
  );
};

export const PUserE2Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.1144 13.4588C12.0954 13.4588 12.0668 13.4588 12.0477 13.4588C12.0191 13.4588 11.9809 13.4588 11.9523 13.4588C9.78792 13.392 8.16699 11.7044 8.16699 9.62576C8.16699 7.50902 9.89281 5.7832 12.0096 5.7832C14.1263 5.7832 15.8521 7.50902 15.8521 9.62576C15.8426 11.7139 14.2121 13.392 12.143 13.4588C12.124 13.4588 12.124 13.4588 12.1144 13.4588ZM12 7.2039C10.6651 7.2039 9.58769 8.29088 9.58769 9.61623C9.58769 10.9225 10.6079 11.9809 11.9047 12.0285C11.9333 12.019 12.0286 12.019 12.124 12.0285C13.4016 11.9618 14.4028 10.913 14.4123 9.61623C14.4123 8.29088 13.3349 7.2039 12 7.2039Z"
        fill="white"
      />
      <path
        d="M12 22.2497C9.43507 22.2497 6.98461 21.2962 5.08717 19.5608C4.91554 19.4083 4.83926 19.1795 4.85833 18.9601C4.98228 17.8255 5.68786 16.7671 6.86065 15.9853C9.70205 14.0974 14.3074 14.0974 17.1393 15.9853C18.312 16.7767 19.0176 17.8255 19.1416 18.9601C19.1702 19.189 19.0844 19.4083 18.9127 19.5608C17.0153 21.2962 14.5648 22.2497 12 22.2497ZM6.35531 18.7695C7.9381 20.0948 9.93089 20.8195 12 20.8195C14.069 20.8195 16.0618 20.0948 17.6446 18.7695C17.473 18.1878 17.0153 17.6253 16.3383 17.1676C13.9927 15.6039 10.0167 15.6039 7.65205 17.1676C6.97507 17.6253 6.52693 18.1878 6.35531 18.7695Z"
        fill="white"
      />
      <path
        d="M12 22.25C6.34581 22.25 1.75 17.6542 1.75 12C1.75 6.34581 6.34581 1.75 12 1.75C17.6542 1.75 22.25 6.34581 22.25 12C22.25 17.6542 17.6542 22.25 12 22.25ZM12 3.18023C7.13721 3.18023 3.18023 7.13721 3.18023 12C3.18023 16.8628 7.13721 20.8198 12 20.8198C16.8628 20.8198 20.8198 16.8628 20.8198 12C20.8198 7.13721 16.8628 3.18023 12 3.18023Z"
        fill="white"
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M15 19.92 8.48 13.4c-.77-.77-.77-2.03 0-2.8L15 4.08"
      ></path>
    </svg>
  );
};
